import { CancellationReasonDTO } from "@gymflow/types";
import { AxiosInstance } from "axios";

export type CustomerClubApiType = ReturnType<typeof customerClubApi>;

const customerClubApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    cancellationReason() {
      return axiosInstance.get<CancellationReasonDTO[]>(
        `${clubPrefix}customer/cancellation-reason`,
      );
    },
  };
};

export default customerClubApi;
